@if (!isShowSidebar) {
  <app-burger class="header__burger" (click)="onToggleSidebar()"></app-burger>
}
<app-menu class="header__menu"></app-menu>
<app-fast-search class="header__fast-search"></app-fast-search>
<div class="header__right">
  <ux-avatar [user]="user()" class="header__avatar" (click)="onToggleMenu($event)"></ux-avatar>
  @if (isOpenMenu()) {
    <ux-user-menu (onClose)="onClose()" (clickOutside)="onClose()" [delayClickOutsideInit]="true"></ux-user-menu>
  }
</div>
